import api from '@/plugins/api'
import { deserialize } from 'deserialize-json-api'

const errorPage = {
  namespaced: true,
  state: () => ({
    response: null,
    forbidden: null
  }),
  mutations: {
    setResponse (state, response) {
      state.response = response
    },
    setForbidden (state, forbidden) {
      state.forbidden = forbidden
    }
  },
  getters: {
    isNotFound (state) {
      return state.response && state.response.status.toString() === '404'
    }
  },
  actions: {
    async checkNotFound (context) {
      try {
        const { data } = await api.fetchSiteCommon()
        context.commit('SiteStore/setSiteCommon', deserialize(data).data, { root: true })
      } catch ({ response }) {
        context.commit('setResponse', response)
      }

      return context.getters.isNotFound
    }
  }
}

export default errorPage
